export const siteConfig = {
  name: '冲田杏梨粉丝资讯站',
  tagline: '最全面的冲田杏梨中文资料库',
  description: '冲田杏梨是日本知名写真偶像及演员，本页汇整冲田杏梨的个人资料、出道经历、代表作品、写真集及最新动态，为粉丝提供最全面的一站式信息参考。',
  keywords: '冲田杏梨,冲田杏梨写真集,冲田杏梨作品,冲田杏梨个人资料,冲田杏梨出道经历,冲田杏梨最新动态,冲田杏梨粉丝资讯',
  url: 'https://anri-okita-fan.com',
  locale: 'zh_CN',
  author: '冲田杏梨粉丝资讯站',
  ogImage: 'https://readdy.ai/api/search-image?query=Elegant%20Japanese%20gravure%20idol%20portrait%20with%20warm%20golden%20lighting%20and%20soft%20cream%20background%2C%20professional%20photography%20style%2C%20artistic%20composition%2C%20minimalist%20elegant%20aesthetic&width=1200&height=630&seq=anri-og-image&orientation=landscape',
};

export const celebrityInfo = {
  name: '冲田杏梨',
  nameEn: 'Anri Okita',
  nameJp: '沖田杏梨',
  birthday: '1986年10月28日',
  birthplace: '英国伯明翰（日本籍）',
  height: '168cm',
  measurements: 'B105 / W58 / H88',
  bloodType: 'B型',
  hobbies: ['钢琴', '书法', '英语会话', '旅行', '美食'],
  specialties: ['钢琴演奏', '书法', '英语（流利）'],
  debut: '2011年',
  agency: '自由身',
  socialMedia: {
    twitter: 'https://twitter.com/anri_okita',
    instagram: 'https://www.instagram.com/anri_okita_official/',
  },
  bio: '冲田杏梨（Anri Okita），1986年10月28日出生于英国伯明翰，是一位日本知名的写真偶像、演员及歌手。她拥有英国和日本的成长背景，精通英语和日语，具备出色的语言能力和文化素养。冲田杏梨于2011年正式出道，凭借惊人的身材比例和甜美外表迅速走红，成为日本写真界和演艺圈的标志性人物之一。此后，她积极拓展事业版图，涉足影视表演、音乐创作等多个领域，展现了多才多艺的一面。',
  careerTimeline: [
    { year: '2011', event: '正式出道，迅速获得广泛关注' },
    { year: '2012', event: '发行首本个人写真集，销量突破纪录' },
    { year: '2014', event: '开始涉足主流影视剧演出' },
    { year: '2016', event: '加入音乐团体，展开音乐活动' },
    { year: '2018', event: '活跃于综艺节目和舞台演出' },
    { year: '2020', event: '持续在写真、影视、音乐多领域发展' },
    { year: '2024', event: '自由身份活跃于日本娱乐圈' },
  ],
};